import { SgCalendarView } from '../features/sg-calendar/SgCalendarView';

export function SgCalendarPage() {
  return (
    <div className='p-6'>
      <SgCalendarView />
    </div>
  );
}

export default SgCalendarPage;
